var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24PxIconMessenger = function Svg24PxIconMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12a8.5 8.5 0 1 1 3.958 7.186 1 1 0 0 0-.82-.113l-2.881.859 1.085-2.537a1 1 0 0 0-.07-.92A8.456 8.456 0 0 1 3.5 12ZM12 1.5C6.201 1.5 1.5 6.201 1.5 12c0 1.838.473 3.568 1.305 5.073L1.08 21.107a1 1 0 0 0 1.206 1.351l4.5-1.342A10.455 10.455 0 0 0 12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.8 1.5 12 1.5Z",
    fill: "#0078FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 13.5 3.5-3L13 13l4-3",
    stroke: "#0078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default Svg24PxIconMessenger;